export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="web端-app引流需求-Wave详情页" transform="translate(-1301.000000, -1002.000000)" fill="#2673FF" fillRule="nonzero">
                    <g id="编组-3" transform="translate(1185.000000, 997.000000)">
                        <polygon
                            id="路径"
                            points="117.830973 5 130 5 130 17.1690266 128.023499 17.1690266 128.022754 8.37422806 117.397597 19 116 17.602403 126.625157 6.97663103 117.830973 6.97650068"
                        ></polygon>
                    </g>
                </g>
            </g>
        </svg>
    );
}
